import { render, staticRenderFns } from "./CambioLista.vue?vue&type=template&id=6be899a7"
import script from "./CambioLista.vue?vue&type=script&lang=js"
export * from "./CambioLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports